import v1 from './v1.vue';
import v1_mobile from './v1_mobile.vue';

export default {
  v1,
  v1_mobile
}
